import { useCallback } from 'react';

import { useConvertLeadTracking } from '../../helpers/experiments/tracking/useConvertLeadTracking';
import { CONVERT_GOAL_KEYS } from '../../helpers/experiments/tracking/convertGoalKeys';
import { useConvertContext } from '../../contexts/ConvertContext';
import { FEATURE_PRICING_INDICATOR } from '../../utils';
import {
  SELLER_TYPES,
  type SellerTypes,
} from '../PageWrappers/AdDetails/types';
import { PAGE } from '../../helpers/pages';

// These are ok not to live in a separate file
// Once the experiment is over, this file can be deleted

type PricingIndicatorLeadTrackingProps = {
  page: PAGE;
};

type PricingIndicatorLeadProps = {
  sectionName?: string;
  sellerType?: SellerTypes;
  price?: string | null;
};

const usePricingIndicatorLeadTracking = (
  props: PricingIndicatorLeadTrackingProps,
) => {
  const { trackLead } = useConvertLeadTracking(props);
  const { pricingIndicatorVariationKey } = useConvertContext(props);

  const trackPricingIndicatorLead = useCallback(
    (leadProps: PricingIndicatorLeadProps) => {
      const { sectionName, sellerType, price } = leadProps;

      const numericPrice = Number(String(price ?? '').replace(/,/g, ''));

      const shouldTrack =
        FEATURE_PRICING_INDICATOR &&
        sectionName === 'cars' &&
        sellerType === SELLER_TYPES.DEALER &&
        pricingIndicatorVariationKey !== null &&
        price != null &&
        !Number.isNaN(numericPrice) &&
        numericPrice > 0;

      if (!shouldTrack) return;

      const isOver20K = numericPrice >= 20000;

      /**
       * If an ad is >= 20K, we track both PRO_LEAD_GENERATED and PRO_LEAD_GENERATED_OVER_20K
       * If it's under 20K, we only track PRO_LEAD_GENERATED
       */

      trackLead(CONVERT_GOAL_KEYS.PRO_LEAD_GENERATED);

      if (isOver20K) {
        trackLead(CONVERT_GOAL_KEYS.PRO_LEAD_GENERATED_OVER_20K);
      }
    },
    [pricingIndicatorVariationKey, trackLead],
  );

  return { trackPricingIndicatorLead };
};

export { usePricingIndicatorLeadTracking, type PricingIndicatorLeadProps };
